/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
/* eslint-disable jsx-a11y/anchor-is-valid  */
import React from "react";
import { Container } from "app/components";
import { BlockMainWrapper, imageStyle, BrandImagesWrapper } from "./styles";
import Visa from "../../assets/images/Brand/visa.png";
import VisaSecure from "../../assets/images/Brand/visa_secure.png";
import DinaCard from "../../assets/images/Brand/dina_card.png";
import OtpBanka from "../../assets/images/Brand/otp_banka.png";
import Mc_Id from "../../assets/images/Brand/mc_id.png";
import Maestro from "../../assets/images/Brand/maestro.png";
import MasterCard from "../../assets/images/Brand/master_card.png";
import Monri from "../../assets/images/Brand/monri_logo.jpg";

const BlockBrand = () => {
  return (
    <BlockMainWrapper>
      <div className="fotterTop">
        <Container>
          <BrandImagesWrapper>
            <a
              href="https://rs.visa.com/pay-with-visa/security-and-assistance/protected-everywhere.html"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={VisaSecure}
                alt="Visa Secure"
                style={{ ...imageStyle, height: "55px" }}
              />
            </a>

            <a
              href="https://developer.mastercard.com/product/identity-check/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={Mc_Id}
                alt="MC ID"
                style={{ ...imageStyle, height: "55px" }}
              />
            </a>

            <a href="https://www.otpbanka.rs/" target="_blank" rel="noreferrer">
              <img src={OtpBanka} alt="OTP Banka" style={imageStyle} />
            </a>
            
            <a href="https://monri.rs/" target="_blank" rel="noreferrer">
              <img src={Monri} alt="Monri" style={imageStyle} />
            </a>

            <img
              src={Maestro}
              alt="Maestro"
              style={{ ...imageStyle, height: "65px" }}
            />

            <img
              src={MasterCard}
              alt="MasterCard"
              style={{ ...imageStyle, height: "65px" }}
            />

            <img src={Visa} alt="Visa" style={imageStyle} />

            <img src={DinaCard} alt="Dina Card" style={imageStyle} />
          </BrandImagesWrapper>

          {/* <BrandImagesWrapper>

            <a href="#" onClick={e => e.preventDefault()} rel="noreferrer">
              <img
                src={Maestro}
                alt="Maestro"
                style={{ ...imageStyle, height: "65px" }}
              />
            </a>

            <a href="#" onClick={e => e.preventDefault()} rel="noreferrer">
              <img
                src={MasterCard}
                alt="MasterCard"
                style={{ ...imageStyle, height: "65px" }}
              />
            </a>

            <a href="#" onClick={e => e.preventDefault()} rel="noreferrer">
              <img src={Visa} alt="Visa" style={imageStyle} />
            </a>

            <a href="#" onClick={e => e.preventDefault()} rel="noreferrer">
              <img src={DinaCard} alt="Dina Card" style={imageStyle} />
            </a>

            <a href="https://www.otpbanka.rs/" target="_blank" rel="noreferrer">
              <img src={OtpBanka} alt="OTP Banka" style={imageStyle} />
            </a>

            <a
              href="https://rs.visa.com/pay-with-visa/security-and-assistance/protected-everywhere.html"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={VisaSecure}
                alt="Visa Secure"
                style={{ ...imageStyle, height: "55px" }}
              />
            </a>

            <a
              href="https://developer.mastercard.com/product/identity-check/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={Mc_Id}
                alt="MC ID"
                style={{ ...imageStyle, height: "55px" }}
              />
            </a>
          </BrandImagesWrapper> */}

        </Container>
      </div>
    </BlockMainWrapper>
  );
};

export default BlockBrand;
